import { P2Modal } from "react-bootstrap-common-script";
interface BackConfirmationModalProps {
  onClose?: () => void;
  onSubmit: () => void;
  isOpen: boolean;
}

export default function BackConfirmationModal({
  onClose,
  onSubmit,
  isOpen
}: BackConfirmationModalProps) {

  return (
    <P2Modal
      isOpen={isOpen}
      onCloseModal={onClose}
      variant="default"
      title={`Changes made in the previous steps will reset your form`} // in future to change to .length
      secondaryButtonText="Close"
      secondaryButtonFunction={onSubmit}
      className={"polymer-back-confirmation-modal"}
      children={
        <p style={{marginBottom: "32px"}}>
          Going back to the previous steps and changing any fields will affect the next steps. You may need to fill up the form again if you change any fields in the previous steps. 
        </p>
      }
    />
  );
}
